import { JsonObject, JsonProperty } from 'json-ts-mapper';
import { CodeDomaine } from './enum-types/code-domaine';
import { CodeTypeLieuDepart } from './enum-types/type-lieu-depart';

@JsonObject
export class LieuDepart {
  constructor (
    id?: number,
    domaine?: CodeDomaine,
    code?: string,
    libelle?: string,
    typeLieuDepart?: CodeTypeLieuDepart
  ) {
    this.id = id as any;
    this.domaine = domaine as any;
    this.code = code as any;
    this.libelle = libelle as any;
    this.typeLieuDepart = typeLieuDepart as any;
  }

  @JsonProperty(Number)
  id: number;

  @JsonProperty(String)
  domaine: CodeDomaine;

  @JsonProperty(String)
  code: string;

  @JsonProperty(String)
  libelle: string;

  @JsonProperty(String)
  typeLieuDepart: CodeTypeLieuDepart;
}
